import  {  useEffect, useLayoutEffect } from 'react';
import {
  useLocation,
  useRoutes,
  useNavigate

  
} from 'react-router-dom';

// Redux
import { useSelector } from 'react-redux';
import { globalState } from '../globalSlice/globalSlice';

// Media query
import { useMediaQuery } from 'react-responsive';

import ScrollToTop from './ScrollToTop';

import { useCookies } from 'react-cookie';
import { WhiteboxLoader } from '../../components/Loader/Loader';

import {routesObject} from './routes'


const  AppRoutes =() => {
  // Redux
  const globalState = useSelector(
    (state: { global: globalState }) => state.global,
  );
  

  // Cookies hooks
  const [cookies] = useCookies();
  const routes=useRoutes(routesObject(cookies.userinfo))
  const navigate =useNavigate()
const location =useLocation()
  // Media querys
  // const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1px)' });

  useLayoutEffect(() => {
    if (localStorage.getItem('lang'))
      document.body.classList.add(
        localStorage.getItem('lang') === 'ar' ? 'rtl' : 'ltr',
      );
    if (localStorage.getItem('theme'))
      document.body.classList.add(String(localStorage.getItem('theme')));
  }, []);

useEffect(()=>{
if (!cookies.userinfo) {
  
  navigate('/login')
}

}
,[location.pathname,cookies.userinfo,navigate]) 

 return (
    <>
      {isTabletOrMobile && false ? (
        <div
          className="center"
          style={{
            fontSize: '30px',
            width: '100%',
            padding: 20,
            textAlign: 'center',
          }}>
          Coming soon...
        </div>
      ) : (
     <>
            
          {globalState.isLoading ? <WhiteboxLoader /> : ''}
          <ScrollToTop>
             
                {
                    
                        
                            routes
                        

                    
                }
    
            {/* {!cookies.userinfo ? (
              // Auth pages
              <Switch>
                <Route exact path="/" component={Login} />
                <Route path="/" component={() => <Redirect to="/" />} />
              </Switch>
            ) : (
              // Dashboard pages
              <Switch>
               
                <Route
                  
                  
                  path="/orders/clientid/:clientid"
                  component={Order}
                />
                <Route exact path="/orders/:orderId" component={Order} />
                {/* <Route exact path="/report/client/:client_id/orders" component={(props: any) => <Report {...props} client_report_type="orders" />} />
                                <Route exact path="/report/client/:client_id/bills" component={(props: any) => <Report {...props} client_report_type="bills" />} />
                                <Route exact path="/report/client/:client_id/account_statement" component={(props: any) => <Report {...props} account_statement_report_type="client" />} />
                                <Route exact path="/report/supplier/:client_id/account_statement" component={(props: any) => <Report {...props} account_statement_report_type="supplier" />} />
                                <Route exact path="/report/order/:order_id/bill" component={(props: any) => <Report {...props} order_report_type="bill" />} />
                                <Route exact path="/report/order/:order_id/grouped-bill" component={(props: any) => <Report {...props} order_report_type="grouped-bill" />} />
                                <Route exact path="/report/order/:order_id/executive-order" component={(props: any) => <Report {...props} order_report_type="executive-order" />} />
                                <Route exact path="/report/:report_name" component={Report} />
                                <Route exact path="/report/:report_name/:type" component={Report} />
                         

                <Route path="/:section" component={Dashboard} />
                <Route path="/" component={Dashboard} />
              </Switch>
            )} */}
          </ScrollToTop>
   </>
      )}
    </>
  );
};
export default AppRoutes;